import styled from "styled-components";
import { DeleteButton } from "../../routes/dashboard/devices/devices.styles";
import { Icon } from "../dashboardComponents/dashboard.styles";
export const StaffCardContainer = styled.div`
  background-color: ${({ theme: { colors } }) => colors.white};
  padding: 1rem 1.5rem;
  width: 290px;
`;
export const MemberStatusContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
  margin-bottom: 1rem;
`;
export const MemberStatus = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
`;
export const StatusIcon = styled.img`
  width: 38px;
  height: 38px;
`;

export const MemberImage = styled.img`
  width: 100%;
  aspect-ratio: 1/1;
  margin-bottom: 1rem;
  object-fit: cover;
`;
export const MemberNameContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
`;
export const MemberName = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
`;
export const MemberRole = styled.h3`
  font-size: 1.4rem;
  font-weight: 600;
`;
export const MemberDetails = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 0.7rem;
`;

export const EditButton = styled(DeleteButton)`
  width: 47%;
  color: ${({ theme: { colors } }) => colors.black};
  border: 1px solid ${({ theme: { colors } }) => colors.black};
  gap: 0.5rem;
`;
export const QrCodeIcon = styled(Icon)`
  filter: brightness(0);
  transition: opacity 0.2s ease-in-out;
  &:hover {
    opacity: 0.5;
  }
`;
export const MemberPhone = styled.p`
  body[dir="rtl"] & {
    direction: ltr;
    text-align: right;
  }
`;
